var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.position != -1)?_c('div',{staticClass:"create_slot_place",style:({
        'top': _vm.position + 'px',
        'height': _vm.tableCeilHeight() + 'px',
    })},[_vm._v(" New event ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }